import React, { useEffect, useState } from "react";
import { Row, Col } from "../../ui/Grid";
import Skeleton from "../../ui/Skeleton";

import addressPicture from "../../FormLocalSearch/assets/audit/adresse.png";
import siteGood from "../../FormLocalSearch/assets/audit/site-web-good.jpg";
import siteWrong from "../../FormLocalSearch/assets/audit/site-web-wrong.jpg";
import horairesPicture from "../../FormLocalSearch/assets/audit/Horaires.png";
import phonePicture from "../../FormLocalSearch/assets/audit/telephone.png";
import descriptionPicture from "../../FormLocalSearch/assets/audit/description.png";
import ProgressCircle from "../ProgressCircle";
import useLang from "../../../i18n/useLang";
import content from "./content";

const Informations = ({ auditInfo }) => {
  const all = content[useLang()];
  const t = all.informations;
  const [score, setScore] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getScore = async () => {
      let score = 0;
      if (auditInfo.Address) {
        score = score + 20;
      }
      if (auditInfo.Phone) {
        score = score + 20;
      }
      if (auditInfo.Website) {
        score = score + 20;
      }
      if (auditInfo.IsBusinessHoursFilled) {
        score = score + 20;
      }
      if (auditInfo.MerchandDescription) {
        score = score + 20;
      }
      setScore(score);
      setLoading(false);
    };
    getScore();
  }, [
    auditInfo.Address,
    auditInfo.Phone,
    auditInfo.Website,
    auditInfo.IsBusinessHoursFilled,
    auditInfo.MerchandDescription,
  ]);

  if (loading) {
    return (
      <>
        <div className="featureblock-container">
          <div className="card-header">
            <span>{all.essentials.title}</span>
          </div>
          <div className="card-graph-body">
            <div className="sumup-category">
              <Skeleton />
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <div className="featureblock-container">
        <div className="card-header">
          <span>{t.title}</span>
        </div>
        <div className="card-graph-body">
          <div className="sumup-category">
            <Row>
              <Col xl={10} lg={10} sm={24} className="progress-category">
                <ProgressCircle type="circle" score={score} />
              </Col>
              <Col xl={14} lg={14} sm={24}>
                <div style={{ marginTop: "20px" }}>
                  {t.intro}
                </div>
              </Col>
            </Row>
          </div>
          <div className="criteria-audit">
            <Row gutter={30}>
              <Col xl={14} lg={14} sm={24}>
                <div className="criteria-status">
                  <span>
                    {auditInfo.Address ? (
                      <>
                        <span
                          role="img"
                          className="issue-icon"
                          aria-label="emoji"
                        >
                          ✅
                        </span>
                        {t.address}{" "}
                      </>
                    ) : (
                      <>
                        <span
                          role="img"
                          className="issue-icon"
                          aria-label="emoji"
                        >
                          ❌
                        </span>
                        {t.noAddress}
                      </>
                    )}
                  </span>
                </div>
                <div className="criteria-description">
                  <span>{t.addressDesc}</span>
                </div>
              </Col>
              <Col xl={10} lg={10} sm={24}>
                <img src={addressPicture} width="80%" alt={t.addressAlt} />
              </Col>
            </Row>
          </div>
          <div className="criteria-audit">
            <Row gutter={30}>
              <Col xl={14} lg={14} sm={24}>
                <div className="criteria-status">
                  <span>
                    {auditInfo.IsWebsiteFilled ? (
                      <>
                        {" "}
                        <span
                          role="img"
                          className="issue-icon"
                          aria-label="emoji"
                        >
                          ✅
                        </span>
                        {t.website}{" "}
                      </>
                    ) : (
                      <>
                        {" "}
                        <span
                          role="img"
                          className="issue-icon"
                          aria-label="emoji"
                        >
                          ❌
                        </span>
                        {t.noWebsite}
                      </>
                    )}
                  </span>
                </div>
                <div className="criteria-description">
                  {auditInfo.Website ? (
                    <>
                      <span style={{ fontSize: 16 }}>
                        <b>{t.yourWebsite(auditInfo.Website)}</b>
                      </span>
                      <br />
                      <br />
                    </>
                  ) : (
                    ""
                  )}
                  <span>{t.websiteDesc}</span>
                </div>
              </Col>
              <Col xl={10} lg={10} sm={24}>
                {auditInfo.Website ? (
                  <img src={siteGood} width="80%" alt={t.websiteGoodAlt} />
                ) : (
                  <img src={siteWrong} width="80%" alt={t.websiteBadAlt} />
                )}{" "}
              </Col>
            </Row>
          </div>
          <div className="criteria-audit">
            <Row gutter={30}>
              <Col xl={14} lg={14} sm={24}>
                <div className="criteria-status">
                  <span>
                    {auditInfo.IsBusinessHoursFilled ? (
                      <>
                        {" "}
                        <span
                          role="img"
                          className="issue-icon"
                          aria-label="emoji"
                        >
                          ✅
                        </span>
                        {t.hours}{" "}
                      </>
                    ) : (
                      <>
                        {" "}
                        <span
                          role="img"
                          className="issue-icon"
                          aria-label="emoji"
                        >
                          ❌
                        </span>
                        {t.noHours}
                      </>
                    )}
                  </span>
                </div>
                <div className="criteria-description">
                  <span>{t.hoursDesc}</span>
                </div>
              </Col>
              <Col xl={10} lg={10} sm={24}>
                <img src={horairesPicture} width="80%" alt={t.hoursAlt} />
              </Col>
            </Row>
          </div>
          <div className="criteria-audit">
            <Row gutter={30}>
              <Col xl={14} lg={14} sm={24}>
                <div className="criteria-status">
                  <span>
                    {auditInfo.Phone ? (
                      <>
                        {" "}
                        <span
                          role="img"
                          className="issue-icon"
                          aria-label="emoji"
                        >
                          ✅
                        </span>
                        {t.phone}{" "}
                      </>
                    ) : (
                      <>
                        {" "}
                        <span
                          role="img"
                          className="issue-icon"
                          aria-label="emoji"
                        >
                          ❌
                        </span>
                        {t.noPhone}
                      </>
                    )}
                  </span>
                </div>
                <div className="criteria-description">
                  {auditInfo.Phone ? (
                    <>
                      <span style={{ fontSize: 16 }}>
                        <b>{t.yourPhone(auditInfo.Phone)}</b>
                      </span>
                      <br />
                      <br />
                    </>
                  ) : (
                    ""
                  )}
                  <span>{t.phoneDesc}</span>
                </div>
              </Col>
              <Col xl={10} lg={10} sm={24}>
                <img src={phonePicture} width="80%" alt={t.phoneAlt} />
              </Col>
            </Row>
          </div>
          <div className="criteria-audit">
            <Row gutter={30}>
              <Col xl={14} lg={14} sm={24}>
                <div className="criteria-status">
                  <span>
                    {auditInfo.MerchandDescription ? (
                      <>
                        {" "}
                        <span
                          role="img"
                          className="issue-icon"
                          aria-label="emoji"
                        >
                          ✅
                        </span>
                        {t.description}{" "}
                      </>
                    ) : (
                      <>
                        {" "}
                        <span
                          role="img"
                          className="issue-icon"
                          aria-label="emoji"
                        >
                          ❌
                        </span>
                        {t.noDescription}
                      </>
                    )}
                  </span>
                </div>
                <div className="criteria-description">
                  <span>{t.descriptionDesc}</span>
                </div>
              </Col>
              <Col xl={10} lg={10} sm={24}>
                <img
                  src={descriptionPicture}
                  width="80%"
                  alt={t.descriptionAlt}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
};
export default Informations;
